import { SearchTravelResponse } from '@/types/models';
import { SearchTravelFilterRequest, ValueIndexParams } from '@/types/paramModels';
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';

@Module({ namespaced: true, })
class TravelSearchFilterModule extends VuexModule {
    public searchFilterRequest?: SearchTravelFilterRequest;

    @Mutation
    public setSearchFilterRequest(searchTravelResponse: SearchTravelResponse): void {
        const newSearchFilterRequest = {
            searchKey: searchTravelResponse.searchKey,
            searchFilter: searchTravelResponse.searchFilter,
            paging: searchTravelResponse.paging
        } as SearchTravelFilterRequest;
        this.searchFilterRequest = newSearchFilterRequest;
    }

    @Action
    public updateSearchTravelFilter(searchTravelResponse: SearchTravelResponse): void {
        this.context.commit('setSearchFilterRequest', searchTravelResponse);
    }

    get getSearchFilterRequest(): SearchTravelFilterRequest {
        return this.searchFilterRequest as SearchTravelFilterRequest;
    }

    @Mutation
    private setIncrementPaging(): void {
        if (this.searchFilterRequest)
            this.searchFilterRequest.paging.pageNumber++;

        if (this.searchFilterRequest)
            this.searchFilterRequest.paging.pageNumber++;
    }

    @Action
    public incrementPaging(): void {
        this.context.commit('setIncrementPaging');
    }
    @Mutation
    private setUpdatedFilterStars(params: ValueIndexParams) {
        if(this.searchFilterRequest) {
            this.searchFilterRequest.paging.pageNumber = 1;
            this.searchFilterRequest.searchFilter.stars[params.index].selected = params.value;
        }
    }

    @Action
    public updateFilterStars(params: ValueIndexParams) {
        this.context.commit('setUpdatedFilterStars', params);
    }

    @Mutation
    private setUpdatedFilterCategories(params: ValueIndexParams) {
        if(this.searchFilterRequest) {
            this.searchFilterRequest.paging.pageNumber = 1;
            this.searchFilterRequest.searchFilter.categories[params.index].selected = params.value;
        }
    }

    @Action
    public updateFilterCategories(params: ValueIndexParams) {
        this.context.commit('setUpdatedFilterCategories', params);
    }
}

export default TravelSearchFilterModule;